module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n    uib-modal-animation-class=\"fade\"\n    modal-in-class=\"in\"\n    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n    <div class=\"modal-dialog primary\" ng-class=\"{'modal-small': size == 'sm', 'modal-large': size == 'lg'}\" uib-modal-transclude></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/windowTemplatePrimary.tpl.html
// module id = 941
// module chunks = 12